import { Seo } from "@/seo/Seo";
import { PageHero } from "@/layouts/PageHero";
import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { CtaButton } from "@/components/common/CtaButton";
import { FaqAccordion } from "@/components/detail/FaqAccordion";
import { DetailCta } from "@/components/detail/DetailCta";
import { faqCategories } from "@/data/faqPage.data";
import { siteConfig } from "@/config/site.config";

export default function FAQ() {
  return (
    <>
      <Seo
        title="FAQ"
        description="Frequently asked questions about working with VibeWell — engagements, pricing, timelines, delivery and support."
        path="/faq"
      />
      <PageHero
        eyebrow="FAQ"
        titleLines={["Answers to", "common questions."]}
        description="Everything you might want to know before starting a project with us. Still curious? We're one conversation away."
      >
        <CtaButton to={siteConfig.primaryCta.path} withArrow magnetic>
          Book a Free Consultation
        </CtaButton>
      </PageHero>

      <Section spacing="compact" className="pt-0">
        <Container>
          <div className="mx-auto max-w-3xl space-y-14">
            {faqCategories.map((category) => (
              <div key={category.title}>
                <div className="mb-4 flex items-center gap-3">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent" />
                  <h2 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-primary">
                    {category.title}
                  </h2>
                  <span className="h-px flex-1 bg-border" />
                </div>
                <FaqAccordion faqs={category.items} />
              </div>
            ))}
          </div>
        </Container>
      </Section>

      <DetailCta />
    </>
  );
}
